/* 
This script is used to create the auto scrolling/fade in-out effect for the 
CVP section links in the file sections/rr-customer-value-proposition.liquid
*/

document.addEventListener("DOMContentLoaded", function () {
    const widthControl = document.querySelector(".desktop-width-control");
    if (widthControl) {
        const content = widthControl.innerHTML;

        while (widthControl.scrollWidth <= widthControl.clientWidth) {
            widthControl.innerHTML += content;
        }

        widthControl.innerHTML += content;

        const scrollStep = 2; // Adjust for scrolling speed
        const scrollInterval = 80; // Adjust for smoothness

        function startAutoScroll() {
            setInterval(() => {
                widthControl.scrollLeft = (widthControl.scrollLeft + scrollStep) % (widthControl.scrollWidth / 2);
            }, scrollInterval);
        }
        startAutoScroll();
    }

    const items = document.querySelectorAll(".mobile-width-control .cvp-item");
    let currentIndex = 0;
    const fadeDuration = 500; // Fade duration in milliseconds
    const displayDuration = 3000; // Time each item is displayed before transitioning

    function fadeOut(element, callback) {
        element.style.transition = `opacity ${fadeDuration}ms`;
        element.style.opacity = 0;
        setTimeout(() => {
            element.style.display = "none";
            if (callback) callback();
        }, fadeDuration);
    }

    function fadeIn(element) {
        element.style.display = "flex";
        element.style.opacity = 0;
        element.style.transition = `opacity ${fadeDuration}ms`;
        setTimeout(() => {
            element.style.opacity = 1;
        }, 10); // Slight delay to trigger transition
    }

    function showNextItem() {
        const currentItem = items[currentIndex];
        const nextIndex = (currentIndex + 1) % items.length;
        const nextItem = items[nextIndex];

        fadeOut(currentItem, () => {
            fadeIn(nextItem);
            currentIndex = nextIndex;
            setTimeout(showNextItem, displayDuration);
        });
    }

    // Initialize: Show the first item
    if (items.length > 0) {
        items.forEach(item => {
            item.style.opacity = 0;
            item.style.display = "none";
        });
        fadeIn(items[0]);
        setTimeout(showNextItem, displayDuration);
    }
});

console.log('%cSCRIPT IS WORKING', 'color: hotpink; font-weight: bold;');
